import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Suspense as _Suspense, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "grid" }
const _hoisted_2 = { class: "col-12 lg:col-4" }
const _hoisted_3 = {
  key: 0,
  class: "card"
}
const _hoisted_4 = { class: "p-fluid" }
const _hoisted_5 = {
  key: 1,
  class: "card"
}
const _hoisted_6 = { class: "p-fluid" }
const _hoisted_7 = {
  key: 2,
  class: "card"
}
const _hoisted_8 = { class: "p-fluid" }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "p-fluid" }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "p-fluid" }
const _hoisted_13 = { class: "col-12 lg:col-4" }
const _hoisted_14 = { class: "card" }
const _hoisted_15 = { class: "p-fluid" }
const _hoisted_16 = { class: "col-12 lg:col-4" }
const _hoisted_17 = { class: "card" }
const _hoisted_18 = { class: "p-fluid" }
const _hoisted_19 = {
  key: 0,
  class: "card"
}
const _hoisted_20 = { class: "p-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimeVueToast = _resolveComponent("PrimeVueToast")!
  const _component_PrimeVueConfirmPopup = _resolveComponent("PrimeVueConfirmPopup")!
  const _component_PrimeVueButton = _resolveComponent("PrimeVueButton")!
  const _component_FieldText = _resolveComponent("FieldText")!
  const _component_FieldDropdownNext = _resolveComponent("FieldDropdownNext")!
  const _component_FieldDropdownAutoComplete = _resolveComponent("FieldDropdownAutoComplete")!
  const _component_FieldTextarea = _resolveComponent("FieldTextarea")!
  const _component_Macros = _resolveComponent("Macros")!
  const _component_PrimeVueSkeleton = _resolveComponent("PrimeVueSkeleton")!
  const _component_FieldImageBase64Cropper = _resolveComponent("FieldImageBase64Cropper")!
  const _component_ApprovalStatusComment = _resolveComponent("ApprovalStatusComment")!
  const _component_Entry = _resolveComponent("Entry")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PrimeVueToast),
    _createVNode(_component_PrimeVueConfirmPopup),
    _createVNode(_component_Entry, {
      title: _ctx.$t('creative'),
      entry: _ctx.creative,
      "entry-errors-map": _ctx.creativeErrorsMap,
      "onUpdate:entryErrorsMap": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.creativeErrorsMap) = $event)),
      "entry-fetch-handler": _ctx.fetchCreative,
      "entry-store-handler": _ctx.creative.deleted_at ? null : _ctx.storeCreative,
      "href-prefix": "creatives",
      "on-entry-store-redirect-to-entries": ""
    }, {
      "buttons-col-2-prepend": _withCtx(() => [
        (!!_ctx.creative.id && _ctx.creative.deleted_at)
          ? (_openBlock(), _createBlock(_component_PrimeVueButton, {
              key: 0,
              class: "p-button-success ml-4 mb-0",
              label: "Restore",
              icon: "pi pi-replay",
              loading: !!_ctx.restoringCreativeId,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.restoreCreative(_ctx.creative.id, _ctx.onRestoreSuccess)))
            }, null, 8, ["loading"]))
          : _createCommentVNode("", true),
        (!!_ctx.creative.id && !_ctx.creative.deleted_at)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_PrimeVueButton, {
                class: "p-button-secondary ml-4 mb-0",
                label: _ctx.$t('clone'),
                icon: "pi pi-copy",
                loading: !!_ctx.cloningCreativeId,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirmCloneCreative($event, _ctx.creative.id, _ctx.onCloneSuccess)))
              }, null, 8, ["label", "loading"]),
              _createVNode(_component_PrimeVueButton, {
                class: "p-button-danger p-button-outlined ml-4 mb-0",
                label: _ctx.$t('delete'),
                icon: "pi pi-trash",
                loading: !!_ctx.deletingCreativeId,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmDeleteCreative($event, _ctx.creative.id, _ctx.onDeleteSuccess)))
              }, null, 8, ["label", "loading"])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.creative.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_FieldText, {
                      "model-value": _ctx.creative.id,
                      label: "ID",
                      disabled: ""
                    }, null, 8, ["model-value"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.user.isSuperAdmin())
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_FieldDropdownNext, {
                      modelValue: _ctx.creative.project_id,
                      "onUpdate:modelValue": [
                        _cache[3] || (_cache[3] = ($event: any) => ((_ctx.creative.project_id) = $event)),
                        _ctx.onProjectChange
                      ],
                      modelModifiers: { number: true },
                      name: "project_id",
                      "errors-map": _ctx.creativeErrorsMap,
                      label: _ctx.$t('project'),
                      loading: _ctx.projectsLoading,
                      disabled: !!_ctx.creative.id,
                      options: _ctx.projects.data,
                      "option-value": "id",
                      "option-label": "name"
                    }, null, 8, ["modelValue", "errors-map", "label", "loading", "disabled", "options", "onUpdate:modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.user.isStaff())
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_FieldDropdownAutoComplete, {
                      modelValue: _ctx.creative.user_id,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.creative.user_id) = $event)),
                      modelModifiers: { number: true },
                      name: "user_id",
                      "errors-map": _ctx.creativeErrorsMap,
                      label: _ctx.$t('user'),
                      disabled: !!_ctx.creative.id,
                      "api-url": "/api/v3/users/options",
                      "option-label": "compiled_name"
                    }, null, 8, ["modelValue", "errors-map", "label", "disabled"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.creative.type,
                  "onUpdate:modelValue": [
                    _cache[5] || (_cache[5] = ($event: any) => ((_ctx.creative.type) = $event)),
                    _ctx.onTypeChange
                  ],
                  modelModifiers: { number: true },
                  name: "type",
                  "errors-map": _ctx.creativeErrorsMap,
                  label: "Type",
                  disabled: !!_ctx.creative.id,
                  options: _ctx.CREATIVE_TYPES
                }, null, 8, ["modelValue", "errors-map", "disabled", "options", "onUpdate:modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_FieldText, {
                  modelValue: _ctx.creative.name,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.creative.name) = $event)),
                  modelModifiers: { trim: true },
                  name: "name",
                  "errors-map": _ctx.creativeErrorsMap,
                  label: _ctx.$t('name'),
                  disabled: !!_ctx.creative.deleted_at
                }, null, 8, ["modelValue", "errors-map", "label", "disabled"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                (_ctx.creative.type !== _ctx.CREATIVE_TYPE_BANNER)
                  ? (_openBlock(), _createBlock(_component_FieldText, {
                      key: 0,
                      modelValue: _ctx.creative.title,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.creative.title) = $event)),
                      modelModifiers: { trim: true },
                      name: "title",
                      "errors-map": _ctx.creativeErrorsMap,
                      label: _ctx.$t('title'),
                      "max-length": 32
                    }, null, 8, ["modelValue", "errors-map", "label"]))
                  : _createCommentVNode("", true),
                (_ctx.creative.type !== _ctx.CREATIVE_TYPE_BANNER)
                  ? (_openBlock(), _createBlock(_component_FieldTextarea, {
                      key: 1,
                      modelValue: _ctx.creative.description,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.creative.description) = $event)),
                      modelModifiers: { trim: true },
                      name: "description",
                      "errors-map": _ctx.creativeErrorsMap,
                      label: _ctx.$t('description'),
                      "max-length": 128
                    }, null, 8, ["modelValue", "errors-map", "label"]))
                  : _createCommentVNode("", true),
                (_ctx.creative.type !== _ctx.CREATIVE_TYPE_BANNER)
                  ? (_openBlock(), _createBlock(_Suspense, { key: 2 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Macros, {
                          class: "my-3",
                          macros: ['city']
                        })
                      ]),
                      fallback: _withCtx(() => [
                        _createVNode(_component_PrimeVueSkeleton, { height: "10px" })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.creative.type === _ctx.CREATIVE_TYPE_PUSH)
                  ? (_openBlock(), _createBlock(_Suspense, { key: 3 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_FieldImageBase64Cropper, {
                          modelValue: _ctx.creativeMedia.icon_base64,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.creativeMedia.icon_base64) = $event)),
                          "image-url": _ctx.creative.icon_url,
                          name: "icon_base64",
                          "errors-map": _ctx.creativeErrorsMap,
                          label: _ctx.$t('icon'),
                          "preview-max-width": 128,
                          "stencil-props": { aspectRatio: 1 },
                          disabled: !!_ctx.creative.deleted_at
                        }, null, 8, ["modelValue", "image-url", "errors-map", "label", "disabled"])
                      ]),
                      fallback: _withCtx(() => [
                        _createVNode(_component_PrimeVueSkeleton, { height: "50px" })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.creative.type !== _ctx.CREATIVE_TYPE_PUSH)
                  ? (_openBlock(), _createBlock(_component_FieldDropdownNext, {
                      key: 4,
                      modelValue: _ctx.creative.image_format,
                      "onUpdate:modelValue": [
                        _cache[10] || (_cache[10] = ($event: any) => ((_ctx.creative.image_format) = $event)),
                        _ctx.onFormatChange
                      ],
                      name: "image_format",
                      "errors-map": _ctx.creativeErrorsMap,
                      label: "Format",
                      disabled: !!_ctx.creative.id || _ctx.creative.type === _ctx.CREATIVE_TYPE_NATIVE,
                      options: _ctx.CREATIVE_IMAGE_FORMATS
                    }, null, 8, ["modelValue", "errors-map", "disabled", "options", "onUpdate:modelValue"]))
                  : _createCommentVNode("", true),
                (_ctx.creative.type === _ctx.CREATIVE_TYPE_PUSH || _ctx.creative.image_format)
                  ? (_openBlock(), _createBlock(_Suspense, { key: 5 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_FieldImageBase64Cropper, {
                          modelValue: _ctx.creativeMedia.image_base64,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.creativeMedia.image_base64) = $event)),
                          "image-url": _ctx.creative.image_url,
                          name: "image_base64",
                          "errors-map": _ctx.creativeErrorsMap,
                          label: _ctx.$t('image'),
                          "stencil-props": _ctx.imageStencilProps,
                          "stencil-size": _ctx.imageStencilSize,
                          disabled: !!_ctx.creative.deleted_at
                        }, null, 8, ["modelValue", "image-url", "errors-map", "label", "stencil-props", "stencil-size", "disabled"])
                      ]),
                      fallback: _withCtx(() => [
                        _createVNode(_component_PrimeVueSkeleton, { height: "50px" })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_FieldDropdownNext, {
                  modelValue: _ctx.creative.approval_status,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.creative.approval_status) = $event)),
                  modelModifiers: { number: true },
                  name: "approval_status",
                  "errors-map": _ctx.creativeErrorsMap,
                  label: _ctx.$t('approval_status'),
                  disabled: _ctx.user.isAffiliate() || !!_ctx.creative.deleted_at,
                  options: _ctx.CREATIVE_APPROVAL_STATUSES,
                  "option-label-translate": ""
                }, null, 8, ["modelValue", "errors-map", "label", "disabled", "options"]),
                (_ctx.creative.approval_status === _ctx.CREATIVE_APPROVAL_STATUS_DECLINED)
                  ? (_openBlock(), _createBlock(_component_ApprovalStatusComment, {
                      key: 0,
                      modelValue: _ctx.creative.approval_status_comment,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.creative.approval_status_comment) = $event)),
                      modelModifiers: { trim: true }
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (!!_ctx.creative.id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_FieldText, {
                      "model-value": _ctx.creative.created_at,
                      label: _ctx.$t('created_at'),
                      disabled: ""
                    }, null, 8, ["model-value", "label"]),
                    _createVNode(_component_FieldText, {
                      "model-value": _ctx.creative.updated_at,
                      label: _ctx.$t('updated_at'),
                      disabled: ""
                    }, null, 8, ["model-value", "label"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["title", "entry", "entry-errors-map", "entry-fetch-handler", "entry-store-handler"])
  ], 64))
}